import React, { useState } from "react";
import { Drawer, Modal } from "antd";
import style from "css/modal.module.css";
import { useMediaQuery } from "react-responsive";

const CAMPUS_URLS = {
  CD0601: "#",
  CD0602: "#",
};

function GuideModal(props) {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 769px) and (max-width: 1023px)",
  });
  const [selectWay, setSelectWay] = useState(1);

  const landingUrl = CAMPUS_URLS[props.campusCd] || CAMPUS_URLS.CD0601;

  const openLandingSite = () => {
    window.open(landingUrl, "_blank", "noopener,noreferrer");
  };

  const closeModal = () => {
    props.close();
    if (selectWay === 2) {
      setSelectWay(1);
    }
  };

  return !isMobile && !isTablet ? (
    <Modal
      open={props.open}
      onCancel={closeModal}
      maskClosable={true}
      width="auto"
      centered
      closable={false}
      footer={null}
    >
      <div className={style.guide_modal}>
        <div className={style.guide_modal_title}>Adobe 신청 후 활성화 방법</div>
        <div className={style.guide_list}>
          <div className={style.guide_list_item}>
            <div className={style.guide_way_list}>
              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_label}>1</div>
                <div className={style.guide_way_list_item_text}>
                  <font style={{ fontWeight: "bold" }} size={4}>
                    Adobe 계정 신청 시스템
                  </font>
                  에 접속합니다.
                </div>
              </div>

              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_label}>2</div>
                <div className={style.guide_way_list_item_text}>
                  계정으로 로그인합니다.
                </div>
              </div>
              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_label}>3</div>
                <div className={style.guide_way_list_item_text}>
                  화면 왼쪽 Adobe 신청 목록에서 ‘승인 완료’ 상태를 확인한 후,
                  ‘다운로드’ 버튼을 클릭합니다.
                </div>
              </div>
              <img
                alt="guide"
                src={`${process.env.REACT_APP_CLIENT_URL}img/my/adobe_guide_1.png`}
                style={{ width: "500px" }}
              />
            </div>
          </div>
          <div className={style.guide_list_item}>
            <div className={style.guide_way_list}>
              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_label}>4</div>
                <div className={style.guide_way_list_item_text}>
                  Adobe 홈페이지(www.adobe.com) 로그인하여 팀 가입을 진행합니다.
                </div>
              </div>
              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_text}>
                  *비밀번호를 모르시는 경우, [암호 재설정] 혹은 [비밀번호 찾기]
                  누르시면, 비밀번호 재설정 메일이 발송됩니다.
                </div>
              </div>
              <div className={style.guide_way_list_item}>
                <div className={style.guide_way_list_item_label}>5</div>
                <div className={style.guide_way_list_item_text}>
                  Adobe Creative Cloud 로그인 시 ‘기관 프로필’로
                  로그인한 경우에만 제품 사용이 가능합니다.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={style.guide_modal_footer}>
          <button
            className={style.guide_modal_link_btn}
            onClick={openLandingSite}
          >
            사이트 바로가기
          </button>
        </div>
      </div>
    </Modal>
  ) : (
    <Drawer
      open={props.open}
      onClose={closeModal}
      closable={false}
      size={600}
      defaultSize={"auto"}
      placement="bottom"
    >
      <div className={style.guide_modal}>
        <div className={style.guide_modal_title}>Adobe 신청 후 활성화 방법</div>
        <div className={style.guide_list}>
          <div className={style.guide_list_item}>
            {selectWay === 1 ? (
              <div className={style.guide_way_list}>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>1</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    Adobe 계정 신청 시스템에 접속합니다.
                  </div>
                </div>

                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>2</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    계정으로 로그인합니다.
                  </div>
                </div>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>3</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    화면 왼쪽 Adobe 신청 목록에서 ‘승인 완료’ 상태를 확인한 후,
                    ‘다운로드’ 버튼을 클릭합니다.
                  </div>
                </div>
                <img
                  alt="guide"
                  src={`${process.env.REACT_APP_CLIENT_URL}img/my/adobe_guide_1.png`}
                />
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>4</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    Adobe 홈페이지(www.adobe.com) 로그인하여 팀 가입을
                    진행합니다.
                  </div>
                </div>
                <div className={style.guide_way_list_item}>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    *비밀번호를 모르시는 경우, [암호 재설정] 혹은 [비밀번호
                    찾기] 누르시면, 비밀번호 재설정 메일이 발송됩니다.
                  </div>
                </div>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>5</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    Adobe Creative Cloud 로그인 시 ‘기관 프로필’로
                    로그인한 경우에만 제품 사용이 가능합니다.
                  </div>
                </div>
              </div>
            ) : (
              <div className={style.guide_way_list}>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>1</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    Adobe 사이트로 접속합니다.
                  </div>
                </div>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>2</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    사이트의 로그인을 진행합니다.
                  </div>
                </div>
                <div className={style.guide_way_list_item}>
                  <div className={style.guide_way_list_item_label}>3</div>
                  <div
                    className={style.guide_way_list_item_text}
                    style={{ fontSize: "14px" }}
                  >
                    앱 다운로드를 받아 실행합니다.
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className={style.guide_modal_footer}>
          <button
            className={style.guide_modal_link_btn}
            onClick={openLandingSite}
          >
            사이트 바로가기
          </button>
        </div>
      </div>
    </Drawer>
  );
}

export default GuideModal;
